import { defineMessages } from 'react-intl';

export const objectWorkspaceMessages = defineMessages({
  additionalNotes: {
    defaultMessage: 'Additional notes',
    id: 'fa8HF+OSlt',
    description: 'Label for additional patient profile context',
  },
  allergies: {
    defaultMessage: 'Allergies',
    id: 'qypylg+tOq',
    description: 'Label for patient allergies',
  },
  currentMedications: {
    defaultMessage: 'Current medications',
    id: 'H9OE4fSW7Q',
    description: 'Label for a patient’s current medications',
  },
  dateOfBirth: {
    defaultMessage: 'Date of birth',
    id: 'S7rRb5EkZk',
    description: 'Label for a patient’s date of birth',
  },
  details: {
    defaultMessage: 'Details',
    id: 'zC3ZOR6NW0',
    description: 'Patient object workspace facet label',
  },
  email: {
    defaultMessage: 'Email',
    id: 'NjG8oZTR7h',
    description: 'Label for a patient’s email address',
  },
  emptyPatientDetail: {
    defaultMessage: '—',
    id: 'Bz/MjptJkG',
    description: 'Placeholder for a patient profile field with no value',
  },
  gender: {
    defaultMessage: 'Gender',
    id: 'm3gN2Ax22I',
    description: 'Label for a patient’s gender',
  },
  genderFemale: {
    defaultMessage: 'Female',
    id: '0oW0p1Ljv4',
    description: 'Display value for a female patient profile gender',
  },
  genderMale: {
    defaultMessage: 'Male',
    id: 'MD5voUSbLJ',
    description: 'Display value for a male patient profile gender',
  },
  genderOther: {
    defaultMessage: 'Other',
    id: 'hASD6I6CP4',
    description: 'Display value for another patient profile gender',
  },
  genderUnknown: {
    defaultMessage: 'Unknown',
    id: 'mglKhiuvdB',
    description: 'Display value for an unknown patient profile gender',
  },
  loadingPatientDetails: {
    defaultMessage: 'Loading patient details',
    id: 'N1UkITPVwa',
    description: 'Accessible status while patient profile details load',
  },
  patientDetailsUnavailable: {
    defaultMessage: 'Patient details are unavailable right now.',
    id: 'smHhnlXwnc',
    description: 'Quiet fallback when patient profile details cannot be loaded',
  },
  pastMedicalHistory: {
    defaultMessage: 'Past medical history',
    id: 'ijDTFVLXBm',
    description: 'Label for a patient’s past medical history',
  },
  phoneNumber: {
    defaultMessage: 'Phone number',
    id: 'zJMIhO54XF',
    description: 'Label for a patient’s phone number',
  },
  addPatient: {
    defaultMessage: 'Add patient',
    id: '27t569Yng3',
    description: 'Action to attach a patient to the selected encounter',
  },
  addWork: {
    defaultMessage: 'Add work',
    id: 'LD6SKYtNfV',
    description: 'Action that adds a new local work item to the object workspace',
  },
  addWorkTab: {
    defaultMessage: 'Add tab',
    id: 'sq0o2SvUs8',
    description: 'Accessible label for adding an object-scoped work tab',
  },
  arrangeReview: {
    defaultMessage: 'Arrange three-month review',
    id: 'uATolTmUSw',
    description: 'Suggested patient work item in the object workspace prototype',
  },
  anchorMoreActions: {
    defaultMessage: 'More actions for {title}',
    id: 'SR++sliIX2',
    description: 'Accessible label for an object anchor card overflow action',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'i9+rOVs1VL',
    description: 'Action that cancels editing the object summary',
  },
  changedMetformin: {
    defaultMessage: 'Changed dosage of metformin to 1g BD',
    id: 'ZzfTWxXx8M',
    description: 'Dummy patient history event in the object workspace prototype',
  },
  closeWorkspace: {
    defaultMessage: 'Close object workspace',
    id: '9q6rhHk5JO',
    description: 'Accessible label for closing the selected object workspace',
  },
  expandObjectPane: {
    defaultMessage: 'Expand {name} object pane',
    id: 'xZgF3i/VGl',
    description:
      'Accessible label for restoring the full patient or encounter pane from its collapsed rail',
  },
  context: {
    defaultMessage: 'Context',
    id: '+fEDELKvvb',
    description: 'Visit object workspace facet label',
  },
  contextDescription: {
    defaultMessage:
      'Relevant visit context will appear here. This prototype content is stored locally.',
    id: 'fD7/iwbVQ5',
    description: 'Dummy empty state for the visit context facet',
  },
  contextHeading: {
    defaultMessage: 'Visit context',
    id: 'NPauorJuTz',
    description: 'Heading for the visit context facet',
  },
  diagnosedDiabetes: {
    defaultMessage: 'Diagnosed diabetes',
    id: 'qPK45N6u+5',
    description: 'Dummy patient history event in the object workspace prototype',
  },
  documents: {
    defaultMessage: 'Documents',
    id: 'NDUIhr9B6L',
    description: 'Object workspace facet label',
  },
  documentsDescription: {
    defaultMessage:
      'Related documents will appear here. This prototype does not load patient files.',
    id: '66lFzlmF4J',
    description: 'Dummy empty state for the object documents facet',
  },
  documentsHeading: {
    defaultMessage: 'Related documents',
    id: 'Dwnx+Bymr4',
    description: 'Heading for the object documents facet',
  },
  dismissWorkTab: {
    defaultMessage: 'Close tab {title}',
    id: 'Ehezx3kCpa',
    description: 'Accessible label for dismissing an object-scoped work tab',
  },
  draftDocuments: {
    defaultMessage: 'Draft documents',
    id: 'diJsXMadu7',
    description: 'Composer suggestion for drafting documents from the selected object',
  },
  editSummary: {
    defaultMessage: 'Edit summary',
    id: 'A+9Wh67Q+C',
    description: 'Accessible label for starting inline editing of the object summary',
  },
  encounterEyebrow: {
    defaultMessage: 'Encounter',
    id: 'u2DLSVf6Fy',
    description: 'Small label above the selected encounter object title',
  },
  followUp: {
    defaultMessage: 'Follow up',
    id: '9q62SypsIC',
    description: 'Composer suggestion for follow-up work about the selected object',
  },
  history: {
    defaultMessage: 'History',
    id: 'm/rVT1/zhL',
    description: 'Patient object workspace facet label',
  },
  historyHeading: {
    defaultMessage: 'Patient history',
    id: 'XSI0ONh+kB',
    description: 'Heading for the patient history facet',
  },
  justNow: {
    defaultMessage: 'Just now',
    id: 'rt5g3V9MUt',
    description: 'Timestamp for a work item just added locally',
  },
  newThread: {
    defaultMessage: 'New',
    id: '6p4L8Eai1D',
    description: 'Initial title for an empty object-scoped work tab',
  },
  nextSteps: {
    defaultMessage: 'Next steps',
    id: 'FeDoeAlubS',
    description: 'Composer suggestion for working on encounter next steps',
  },
  newWorkItem: {
    defaultMessage: 'New work item',
    id: 'ArtMhgBXE+',
    description: 'Label for a locally added prototype work item',
  },
  noDocuments: {
    defaultMessage: 'No documents are loaded in this prototype.',
    id: 'wc1P5KKhL4',
    description: 'Supporting copy for the object documents dummy state',
  },
  objectHarnessLabel: {
    defaultMessage: 'Heidi threads for {name}',
    id: 'oPbKFI0pvV',
    description: 'Accessible label for the object-scoped work harness',
  },
  openLastSession: {
    defaultMessage: 'Open last session',
    id: 'Sv90C5lF3Z',
    description: 'Harness action for opening the most recent session',
  },
  patientObjectPane: {
    defaultMessage: 'Patient details for {name}',
    id: 'M3btM8qXQP',
    description: 'Accessible label for the selected patient object pane',
  },
  openPatientWorkspace: {
    defaultMessage: 'Open patient workspace for {name}',
    id: 'h239qNgI8U',
    description:
      'Accessible label for opening the attached patient from an encounter pane',
  },
  patientIdentityNameAge: {
    defaultMessage: '{name}, {age, number}',
    id: 'HDMGAHtFSD',
    description: 'Attached patient name and age shown in an encounter pane',
  },
  patientIdentityNameSex: {
    defaultMessage: '{name}, {sexInitial}',
    id: '/yJedfbnjy',
    description: 'Attached patient name and sex initial shown in an encounter pane',
  },
  patientIdentityNameSexAge: {
    defaultMessage: '{name}, {sexInitial}, {age, number}',
    id: 'iMG4qvdb9Q',
    description: 'Attached patient name, sex initial, and age shown in an encounter pane',
  },
  plan: {
    defaultMessage: 'Plan',
    id: 'mubjO6RCJD',
    description: 'Visit object workspace facet label',
  },
  planDescription: {
    defaultMessage:
      'Visit actions and follow-up will appear here. This prototype content is stored locally.',
    id: 'dMy8qNvd81',
    description: 'Dummy empty state for the visit plan facet',
  },
  planHeading: {
    defaultMessage: 'Visit plan',
    id: 'ZzB/9WJu1p',
    description: 'Heading for the visit plan facet',
  },
  pullUpDosageChange: {
    defaultMessage: 'Pull up this dosage change',
    id: 'jlxF5EjCHz',
    description: 'Composer suggestion and seeded intent for a patient history event',
  },
  pullUpSession: {
    defaultMessage: 'Pull up the session "{title}"',
    id: 'x4I/rcPGv+',
    description:
      'Composer prefill when a patient session is picked; title is the session name',
  },
  quickBrief: {
    defaultMessage: 'Quick brief',
    id: 'XeAs1FkTE+',
    description: 'Composer suggestion for a concise object summary',
  },
  reviewRecommendations: {
    defaultMessage: 'Review specialist recommendations',
    id: '3hkeapjwTs',
    description: 'Suggested patient work item in the object workspace prototype',
  },
  reviewTreatmentResponse: {
    defaultMessage: 'Review treatment response',
    id: 'GjNP2iyw9l',
    description: 'Suggested patient work item in the object workspace prototype',
  },
  save: {
    defaultMessage: 'Save',
    id: 'viHZLjuARS',
    description: 'Action that saves a local edit to the object summary',
  },
  sentPrescription: {
    defaultMessage: 'Sent prescription',
    id: 'sPkRry5JbF',
    description: 'Dummy patient history event in the object workspace prototype',
  },
  sessions: {
    defaultMessage: 'Sessions',
    id: 'qK7oauakZp',
    description: 'Patient object workspace facet label',
  },
  sessionsHeading: {
    defaultMessage: 'Recent sessions',
    id: 'G7w4eABAx8',
    description: 'Heading for the patient sessions facet',
  },
  loadingPatientSessions: {
    defaultMessage: 'Loading sessions',
    id: 'yWiRUWH+Vr',
    description: 'Accessible status while the patient sessions facet loads',
  },
  patientSessionsUnavailable: {
    defaultMessage: 'Sessions are unavailable right now.',
    id: 'PBpBs9l7Jy',
    description: 'Quiet fallback when the patient sessions cannot be loaded',
  },
  noPatientSessions: {
    defaultMessage: 'No sessions for this patient yet.',
    id: 'jjdmpFZ/hC',
    description: 'Empty state for the patient sessions facet',
  },
  showMorePatientSessions: {
    defaultMessage: 'Show more sessions',
    id: 'ppSUyH5eHM',
    description: 'Loads the next page of sessions in the patient sessions facet',
  },
  startWork: {
    defaultMessage: 'Start work',
    id: 'ffQ0bqSAXU',
    description: 'Composer suggestion for starting work about the selected object',
  },
  summaryInput: {
    defaultMessage: 'Object summary',
    id: 'NIooMbXauI',
    description: 'Accessible label for the editable object summary field',
  },
  switchObject: {
    defaultMessage: 'Switch from {name}',
    id: 'DlAKOh9f3F',
    description: 'Accessible label for opening the recent object switcher',
  },
  timeline: {
    defaultMessage: 'Timeline',
    id: 'kkK9eq4sZ+',
    description: 'Composer suggestion for reviewing a patient timeline',
  },
  visitObjectPane: {
    defaultMessage: 'Visit details for {name}',
    id: 'WbzCIZyv+/',
    description: 'Accessible label for the selected visit object pane',
  },
  workspaceLabel: {
    defaultMessage: 'Workspace for {name}',
    id: 'bEXwq1U/dk',
    description: 'Accessible label for the full selected object workspace',
  },
  workbenchLabel: {
    defaultMessage: 'Heidi workbench for {name}',
    id: 'eQuuzrk1ZJ',
    description: 'Accessible label for the workbench side of the object workspace',
  },
  whatsChanged: {
    defaultMessage: 'What’s changed',
    id: 'Y4z7k1a7iU',
    description: 'Composer suggestion for reviewing recent changes to an object',
  },
  work: {
    defaultMessage: 'Work',
    id: 'XD+H5Qbglz',
    description: 'Object workspace facet label',
  },
  workAddedEarlier: {
    defaultMessage: 'Added earlier',
    id: '0MjyvhlJe1',
    description: 'Dummy timestamp for a suggested work item',
  },
  workAddedLastWeek: {
    defaultMessage: 'Added last week',
    id: 'kvO4mhVnGY',
    description: 'Dummy timestamp for a suggested work item',
  },
  workAddedToday: {
    defaultMessage: 'Added today',
    id: '20cjMLJc2/',
    description: 'Dummy timestamp for a suggested work item',
  },
  workAddedYesterday: {
    defaultMessage: 'Added yesterday',
    id: '42JpnRxsXI',
    description: 'Dummy timestamp for a suggested work item',
  },
  workHeading: {
    defaultMessage: 'Suggested work',
    id: 'COqFaDSqE0',
    description: 'Heading above local suggested work items',
  },
  workTabsLabel: {
    defaultMessage: 'Tabs',
    id: 'vKYTZzqnSW',
    description: 'Accessible label for object-scoped parallel work tabs',
  },
  workRecallList: {
    defaultMessage: 'Add patient to recall list',
    id: 'EsmqCNgAgB',
    description: 'Suggested patient work item in the object workspace prototype',
  },
  visitDraftDocuments: {
    defaultMessage: 'Draft documents from this visit',
    id: 'fZ7mTCHl8B',
    description: 'Suggested visit work item in the object workspace prototype',
  },
  visitFollowUp: {
    defaultMessage: 'Arrange patient follow-up',
    id: 'fh/JmXUV+j',
    description: 'Suggested visit work item in the object workspace prototype',
  },
  visitNextSteps: {
    defaultMessage: 'Review the next steps',
    id: 'G06JA7adv6',
    description: 'Suggested visit work item in the object workspace prototype',
  },
  visitUpdatePlan: {
    defaultMessage: 'Update the care plan',
    id: 'teFfiBbpxj',
    description: 'Suggested visit work item in the object workspace prototype',
  },
});
